module.exports = __webpack_public_path__ + "img/14.75b4e2e2.jpg";